/*
  assets/brand-logo-fit.js
  ---------------------------------------------------------------------------
  Estandariza el tamaño con que se ven los logos de marca en TODO el sitio
  (carrusel "Trusted Brands" de la home, carruseles "Brands that complement your
  work", cuadrícula de /pages/brands, menú Brands del header en escritorio y móvil).

  Problema: cada archivo de logo trae un margen blanco distinto (Elkay ocupa el
  30% de su imagen, Watts el 60%, Chicago Faucets el 100%...), así que con el mismo
  recuadro algunos se ven chicos. Aquí se mide el logo REAL dentro de su imagen
  (se ignoran los píxeles blancos/transparentes) y se le aplica un zoom individual
  (--logo-zoom, usado por transform: scale() en el CSS) para que llene el recuadro.

  - Si la imagen no se puede leer (CORS) o el zoom necesario es mínimo, no se toca.
  - Zoom mínimo 1.12 (menos que eso no vale la pena), máximo 3.2.
  - El logo se centra en su archivo; se escala desde el centro del recuadro.
  - Se vuelve a calcular cuando se agregan logos nuevos (carruseles que se arman
    por JS) y al cambiar el tamaño de la ventana.
*/
(function () {
  'use strict';

  var TARGETS = ['.hub-brand-card__logo', '.brands-grid__image', '.brand-card .brand-logo', '.mega-menu__brand-icon'];
  var FILL = 0.92;     // el logo debe llenar ~92% del límite del recuadro
  var MIN_ZOOM = 1.12;
  var MAX_ZOOM = 3.2;
  var cache = {};      // src -> { w, h, bbox } | null

  function px(v) { return parseFloat(v) || 0; }

  function measure(src, done) {
    if (cache.hasOwnProperty(src)) { done(cache[src]); return; }
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      var res = null;
      try {
        var W = probe.naturalWidth, H = probe.naturalHeight;
        var scale = Math.min(1, 220 / Math.max(W, H));
        var cw = Math.max(1, Math.round(W * scale)), ch = Math.max(1, Math.round(H * scale));
        var canvas = document.createElement('canvas');
        canvas.width = cw; canvas.height = ch;
        var ctx = canvas.getContext('2d');
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, cw, ch);
        ctx.drawImage(probe, 0, 0, cw, ch);
        var data = ctx.getImageData(0, 0, cw, ch).data;
        var x0 = cw, y0 = ch, x1 = -1, y1 = -1;
        for (var y = 0; y < ch; y++) {
          for (var x = 0; x < cw; x++) {
            var i = (y * cw + x) * 4;
            // gris del píxel sobre fondo blanco: logo = lo que NO es casi blanco
            if ((data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114) < 238) {
              if (x < x0) x0 = x; if (x > x1) x1 = x;
              if (y < y0) y0 = y; if (y > y1) y1 = y;
            }
          }
        }
        if (x1 >= 0) res = { w: (x1 - x0 + 1) / cw, h: (y1 - y0 + 1) / ch, W: W, H: H };
      } catch (e) { res = null; }
      cache[src] = res;
      done(res);
    };
    probe.onerror = function () { cache[src] = null; done(null); };
    probe.src = src;
  }

  function frameOf(img) {
    return img.closest('.brand-card') || img.closest('.mega-menu__brand-frame') || img.closest('.hub-brand-card__logo-wrap') || img.closest('.brands-grid__circle') || img.parentElement;
  }

  function apply(img, info) {
    if (!info) return;
    var r = img.getBoundingClientRect();
    var cs = getComputedStyle(img);
    // caja donde se dibuja la imagen (sin el padding propio del <img>)
    var bw = r.width - px(cs.paddingLeft) - px(cs.paddingRight);
    var bh = r.height - px(cs.paddingTop) - px(cs.paddingBottom);
    if (bw < 10 || bh < 10) return;
    // escala a la que se dibuja HOY la imagen completa (object-fit: contain / scale-down)
    var s = Math.min(bw / info.W, bh / info.H);
    var shownW = info.w * info.W * s, shownH = info.h * info.H * s;
    // espacio disponible: la caja del <img> o, en la home, el recuadro de la tarjeta
    var fw = bw, fh = bh;
    if (img.closest('.brand-card')) {
      var card = img.closest('.brand-card'), cc = getComputedStyle(card);
      fw = card.clientWidth - px(cc.paddingLeft) - px(cc.paddingRight);
      fh = card.clientHeight - px(cc.paddingTop) - px(cc.paddingBottom);
    }
    var zoom = Math.min(fw / shownW, fh / shownH) * FILL;
    zoom = Math.max(1, Math.min(MAX_ZOOM, zoom));
    if (zoom < MIN_ZOOM) zoom = 1;
    img.style.setProperty('--logo-zoom', zoom.toFixed(2));
    img.setAttribute('data-logo-zoom', zoom.toFixed(2));
  }

  // Los recuadros cambian de tamaño después de cargar (carruseles, paneles que se
  // abren, ventana): se vuelve a calcular cuando cambia el tamaño del <img> o de su marco.
  var resizer = typeof ResizeObserver === 'function' ? new ResizeObserver(function (entries) {
    entries.forEach(function (e) {
      var img = e.target.__logoFitImg;
      if (img && img.__logoInfo) apply(img, img.__logoInfo);
    });
  }) : null;

  function watch(img) {
    if (!resizer || img.__logoWatched) return;
    img.__logoWatched = true;
    img.__logoFitImg = img;
    resizer.observe(img);
    var fr = frameOf(img);
    if (fr && fr !== img) { fr.__logoFitImg = img; resizer.observe(fr); }
  }

  function process(img) {
    var src = img.currentSrc || img.src;
    if (!src) return;
    var run = function () {
      measure(img.currentSrc || img.src, function (info) {
        img.__logoInfo = info;
        apply(img, info);
        watch(img);
      });
    };
    if (img.complete && img.naturalWidth > 0) run();
    else img.addEventListener('load', run, { once: true });
  }

  function scan(root) {
    TARGETS.forEach(function (sel) {
      (root || document).querySelectorAll(sel).forEach(function (img) {
        if (img.tagName !== 'IMG') return;
        if (!img.__logoFitBound) { img.__logoFitBound = true; }
        process(img);
      });
    });
  }

  var timer;
  function rescan() { clearTimeout(timer); timer = setTimeout(function () { scan(document); }, 120); }

  scan(document);
  document.addEventListener('DOMContentLoaded', function () { scan(document); });
  window.addEventListener('load', function () { scan(document); });
  window.addEventListener('resize', rescan);
  document.addEventListener('shopify:section:load', rescan);
  // carruseles que se arman por JS y paneles que se abren después (menú móvil)
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes && muts[i].addedNodes.length) { rescan(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
